"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _renewCredentials = _interopRequireDefault(require("./renewCredentials"));
var _clearCredentials = _interopRequireDefault(require("./clearCredentials"));
var _getCookie = _interopRequireDefault(require("./getCookie"));
var _constants = _interopRequireDefault(require("./constants"));
var getCredentials = function getCredentials() {
  var signInModeCookieResponse = (0, _getCookie["default"])('signInMode');
  if (!signInModeCookieResponse.cookieExists) {
    _clearCredentials["default"].all();
    return Promise.reject(new Error('Not logged in.'));
  }
  switch (signInModeCookieResponse.cookieValue) {
    case _constants["default"].cognito:
      var cognitoIdTokenCookieResponse = (0, _getCookie["default"])('cognitoIdToken');
      if (cognitoIdTokenCookieResponse.cookieExists) return Promise.resolve({
        idToken: cognitoIdTokenCookieResponse.cookieValue
      });
      return (0, _renewCredentials["default"])();
    case _constants["default"].microsoft:
      var microsoftIdTokenCookieResponse = (0, _getCookie["default"])('microsoftIdToken');
      if (microsoftIdTokenCookieResponse.cookieExists) return Promise.resolve({
        idToken: microsoftIdTokenCookieResponse.cookieValue
      });
      return (0, _renewCredentials["default"])();
    case _constants["default"].google:
      var googleIdTokenCookieResponse = (0, _getCookie["default"])('googleIdToken');
      if (googleIdTokenCookieResponse.cookieExists) return Promise.resolve({
        idToken: googleIdTokenCookieResponse.cookieValue
      });
      return (0, _renewCredentials["default"])();
    default:
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Not logged in.'));
  }
};
var _default = exports["default"] = getCredentials;